import { HttpClient, HttpResponse, HttpHeaders, HttpUrlEncodingCodec, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, flatMap } from 'rxjs/operators';
import { ConfigService } from '../Abstract/config.service';
import { CommonService } from '../Abstract/commons.service';
import { Login } from '../Login/Login';
import { ChangePassword } from '../Login/ChangePassword';

import { Injectable } from '@angular/core';
import { EventsEmitterService } from '../Abstract/emitter.service';
import { Router, RouterModule, Routes, Route, } from '@angular/router';
import { LogService } from '../Abstract/log.service';

export class CustomQueryEncoderHelper extends HttpUrlEncodingCodec {
    encodeKey(k: string): string {
        k = super.encodeKey(k);
        return k.replace(/\+/gi, '%2B');
    }
    encodeValue(v: string): string {
        v = super.encodeValue(v);
        return v.replace(/\+/gi, '%2B');
    }
}


@Injectable()
export class SecurityService extends CommonService{

    public static stopRequests: boolean = false;
    public pageSize: number = 20;

    constructor(http:HttpClient, configService:ConfigService, protected eventsEmitterService: EventsEmitterService, public router:Router, logger: LogService) {
        super(http, configService, logger);
        this.pageSize = this.configService.getPageSize();
    }

    public getPageSize(){
        return this.pageSize;
    }

    /**
     *  Refresh & Access Token Request (Login)
     */
    public sendTokenRequest(login: Login){

        let serviceUrl = this.baseUrl + 'oauth/token';
        let headers = new HttpHeaders({
            'Authorization':'Basic YW5ndWxhcjItY2xpZW50OmFuZ3VsYXIy',
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        let data: HttpParams = new HttpParams({encoder: new CustomQueryEncoderHelper()});
        data = data.append('grant_type',login.grant_type);
        data =data.append('credentials','true');
        data = data.append('scope','write');
        data =data.append('username', login.username);
        data =data.append('password', login.password);
        data =data.append('client_id','angular2-client');
        data =data.append('client_secret','angular2');
        let requestHeaders = new HttpHeaders({'Content-Type': 'application/json'});

        let options = {
            method  :   'POST',
            headers :   headers
        }

        return this.http.post<any>(serviceUrl,data.toString(), options).pipe(map(response => {return response;}));
    }

    /**
     *  Change Password Request (Expires Password)
     */
    public changePasswordRequest(changePassword: ChangePassword){

        let serviceUrl = this.baseUrl + 'LoginService/changePwd?token='+changePassword.token + '&id='+ changePassword.token + '&new='+ changePassword.passwordNew + '&matchNewPassword=' + changePassword.passwordNewR;
        let headers = new HttpHeaders({
        });
        let options = ({ headers: headers });

        return this.http.post(serviceUrl, options).pipe(map(this.extractData),catchError(this.handleError));
    }
    
    /**
     *  Change Forgotten Password Request (Expires Password)
     */
    public forgotPasswordRequest(changePassword: ChangePassword){

        let serviceUrl = this.baseUrl + 'LoginService/forgotPwd?token='+changePassword.token + '&id='+ changePassword.token + '&new='+ changePassword.passwordNew + '&matchNewPassword=' + changePassword.passwordNewR;
        let headers = new HttpHeaders({
        });
        let options = ({ headers: headers });

        return this.http.post(serviceUrl, options).pipe(map(this.extractData),catchError(this.handleError));
    }    

    /**
     *  Check Access Token Validity before request that cannot (e.g. File Upload)
     */
    public checkToken(){
        let serviceUrl = this.baseUrl + 'RoutesService/check';
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    /**
     * Logged user Type { C, D, B }
     */
    public getAuthorizedType(){
        let serviceUrl = this.baseUrl + 'AuthorizationService/getAuthorizedType';
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    /**
     * Check if debtor has reverse factoring
     */
    public isReverse(){
        let serviceUrl = this.baseUrl + 'AuthorizationService/isReverse';
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }


    /**
     *  Refresh the Access Token (on expiration)
     */
     public refreshTokenRequest():Observable<HttpResponse<any>>{

        let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
        let options = { 'headers': headers };
        let credentials = "grant_type=refresh_token"
                        + '&client_id=angular2-client'
                        + '&client_secret=angular2'
                        + "&refresh_token="  + this.getFromStorage('refresh_token')
                        + "&access_token="  +this.getFromStorage('access_token');
        let serviceUrl = this.baseUrl + 'oauth/token';

        return this.http.post(serviceUrl, credentials, options).pipe(map((x:HttpResponse<any>) => this.saveData(x)),catchError(this.handleError));
    }

    /**
     *  Revoke Tokens (on logout)
     */
    public revokeToken(){
        let headers = new HttpHeaders({'Authorization':'Bearer '+ localStorage.getItem('access_token')});
        let options = ({ headers: headers });
        let serviceUrl = this.baseUrl + 'oauth/revoke-token';

        return this.http.get(serviceUrl,options).pipe(map(this.extractStatus),catchError(this.handleError));
    }

    public revokeRefreshToken(){    
        let params = new URLSearchParams();
        params.append('token', this.getFromStorage('refresh_token'));

        let options = ({  method: 'POST', body: params });
        let serviceUrl = this.baseUrl + 'oauth/revoke-refresh-token';

        return this.http.post<any>(serviceUrl,options).pipe(map(response => {return response;}));
    }

    public goToLogin(paramName?:string,paramVal?:string):void{
        this.clearStorages();
        SecurityService.stopRequests = false;
        if(this.configService.getIsLogoutExternal()){
            window.location.href = this.configService.getLogoutUrl();
        }else{
            if(paramName && paramVal){
                let params = {};
                params[paramName] = paramVal;        

                this.router.navigate(['/login', params])
            
            } else {
                this.router.navigateByUrl('login');
                //window.location.href = this.configService.getLogoutUrl();
            };
        }
    }

    public navigateTo(menuId:string, paramName?:string[], paramVal?:string[]):void{
        SecurityService.stopRequests = false;
        if(paramName && paramVal){
            let params = {};
            paramName.forEach((element, index)=>{
                params[element] = paramVal[index];
            });
            this.logger.log('Navigate params: ' + JSON.stringify(params));
            this.router.navigate(['/menu/' + menuId, JSON.stringify(params)])
        } else {
            this.router.navigateByUrl('menu/' + menuId);
        };
    }

    /**
     *  Logout Service for log history
     */
  

    /**
     * All logout requests
     *
     * @param expired
     */

    public setAuthorizationHeader(headers: HttpHeaders){
        if (headers) {
            headers = headers.append('Authorization','Bearer '+ this.getFromStorage('access_token'));
            headers = headers.append('Accept-Language' ,  this.configService.getLocale().toString());
        } else {
            headers = new HttpHeaders({'Authorization': 'Bearer '+ this.getFromStorage('access_token'),
                                    'Accept-Language': this.configService.getLocale().toString()});
        }
        return headers;
    }
}